import DoDisturbOnOutlinedIcon from '@mui/icons-material/DoDisturbOnOutlined';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { Control } from 'react-hook-form';

import { AllFormFieldTypes } from './FormFieldTypes';
import FormViewFieldLayout from './FormViewFieldLayout';

const FormView = ({
  afterMainFields,
  beforeMainFields,
  columnNumber,
  control,
  header,
  isDeactivated,
  isReadOnly,
  mainFieldsConfig,
}: {
  afterMainFields?: ReactNode;
  beforeMainFields?: ReactNode;
  columnNumber?: 1 | 2 | 3;
  control: Control<any>;
  header?: string | ReactNode;
  isDeactivated?: boolean;
  isReadOnly?: boolean;
  mainFieldsConfig: AllFormFieldTypes[];
}) => {
  return (
    <Stack
      direction="column"
      spacing={2}
      sx={{ width: 'auto', minWidth: 0, flex: '2 1 0' }}
    >
      {header &&
        (typeof header === 'string' ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 3,
            }}
          >
            <Typography variant="h6">{header}</Typography>
            {isDeactivated && (
              <Chip
                icon={
                  <DoDisturbOnOutlinedIcon
                    fontSize="small"
                    aria-label="Deactivated"
                  />
                }
                color="error"
                label="DEACTIVATED"
                size="small"
              />
            )}
          </Box>
        ) : (
          header
        ))}
      {beforeMainFields}
      <FormViewFieldLayout
        control={control}
        mainFieldsConfig={mainFieldsConfig}
        columnNumber={columnNumber}
        isDeactivated={isDeactivated}
        isReadOnly={isReadOnly}
      />
      {afterMainFields}
    </Stack>
  );
};

export default FormView;
